module.exports = __webpack_public_path__ + "img/bg-img2.f82b2ad1.png";